var _style, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 445.5 143.61",
    style: {
      enableBackground: "new 0 0 445.5 143.61"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FAB314;}\r\n\t.st2{display:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "91.33,56.44 75.51,102.02 42.9,11.44 9.79,11.44 60,131.88 91.12,131.88 123.54,56.44  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.54,131.88h-18.84V55.8h18.84V131.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171,131.88V55.8h28.14c8.04,0,15.23,1.51,21.58,4.52c6.34,3.01,11.29,7.3,14.85,12.85 c3.56,5.56,5.34,11.87,5.34,18.94v3.5c0,7.07-1.75,13.36-5.24,18.86c-3.5,5.5-8.43,9.77-14.79,12.8s-13.55,4.56-21.54,4.6H171z  M189.84,68.49v50.79h9.11c7.37,0,13-2,16.9-6.01c3.89-4.01,5.88-9.74,5.97-17.19v-4.02c0-7.73-1.93-13.59-5.78-17.58 c-3.85-3.99-9.48-5.98-16.9-5.98H189.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75.4,17.9 68.34,38.03 61.26,17.9 55.73,17.9 55.73,32.47 59.92,44.17 59.98,44.17 59.98,35.51  59.56,23.94 66.79,44.17 69.84,44.17 77.09,23.93 76.67,35.51 76.67,44.17 80.92,44.17 80.92,17.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,38.05h-9.51l-1.99,6.12h-4.43l9.27-26.27h3.83l9.29,26.27h-4.45L100,38.05z M91.69,34.37h7.11 l-3.56-10.9L91.69,34.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.26,34.06h-4.75v10.1h-4.26V17.9h8.63c2.83,0,5.02,0.68,6.56,2.04c1.54,1.36,2.31,3.33,2.31,5.9 c0,1.76-0.4,3.23-1.19,4.41c-0.79,1.19-1.9,2.1-3.31,2.73l5.51,10.94v0.23h-4.57L118.26,34.06z M113.5,30.38h4.38 c1.44,0,2.56-0.39,3.37-1.16s1.21-1.84,1.21-3.18c0-1.41-0.37-2.5-1.12-3.27c-0.75-0.77-1.86-1.17-3.35-1.19h-4.5V30.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.83,32.82l-2.78,3.16v8.19h-4.26V17.9h4.26v12.32l2.36-3.12l7.18-9.2h5.16l-9.12,11.64l9.64,14.63h-5.06 L137.83,32.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.89,32.44h-10.08v8.08h11.78v3.64h-16.05V17.9h15.93v3.68h-11.67v7.25h10.08V32.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.14,21.58h-7.65v22.58h-4.23V21.58h-7.59V17.9h19.47V21.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.86,44.17h-4.25V17.9h4.25V44.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.57,44.17h-4.26l-10.94-18.63v18.63h-4.26V17.9h4.26l10.97,18.71V17.9h4.23V44.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.43,40.76c-0.89,1.24-2.12,2.18-3.69,2.81c-1.57,0.64-3.36,0.96-5.36,0.96c-2.06,0-3.88-0.5-5.46-1.5 c-1.58-1-2.81-2.43-3.67-4.28c-0.86-1.86-1.31-4.02-1.34-6.5v-2.06c0-3.97,0.89-7.07,2.66-9.3c1.78-2.23,4.25-3.35,7.43-3.35 c2.73,0,4.9,0.72,6.51,2.17s2.57,3.53,2.9,6.25h-4.18c-0.47-3.16-2.19-4.74-5.14-4.74c-1.91,0-3.36,0.74-4.36,2.21 s-1.51,3.63-1.54,6.48v2.02c0,2.84,0.56,5.04,1.68,6.61c1.12,1.57,2.67,2.35,4.66,2.35c2.18,0,3.73-0.53,4.65-1.59v-5.14h-5.06 v-3.46h9.31V40.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.24,17.9l7.08,20.13l7.06-20.13h5.51v26.27h-4.25v-8.66l0.42-11.58l-7.25,20.24h-3.05l-7.23-20.22 l0.42,11.56v8.66h-4.25V17.9H265.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.44,44.17h-4.25V17.9h4.25V44.17z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "316.93,21.58 316.93,17.9 297.46,17.9 297.46,21.58 305.04,21.58 305.04,44.2 309.28,35.63  309.28,21.58  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.48,45.86c-3.39-8.01-8.24-15.2-14.41-21.38c-6.18-6.18-13.37-11.03-21.38-14.41 c-8.3-3.51-17.11-5.29-26.19-5.29c-9.08,0-17.89,1.78-26.19,5.29c-8.01,3.39-15.2,8.24-21.38,14.41 c-6.18,6.18-11.03,13.37-14.41,21.38c-3.51,8.3-5.29,17.11-5.29,26.19s1.78,17.89,5.29,26.19c3.39,8.01,8.24,15.2,14.41,21.38 c6.18,6.18,13.37,11.03,21.38,14.41c8.3,3.51,17.11,5.29,26.19,5.29c9.08,0,17.89-1.78,26.19-5.29 c8.01-3.39,15.2-8.24,21.38-14.41c6.18-6.18,11.03-13.37,14.41-21.38c3.51-8.3,5.29-17.11,5.29-26.19S438.99,54.16,435.48,45.86z  M373.5,133.2c-33.77,0-61.15-27.38-61.15-61.15c0-33.77,27.38-61.15,61.15-61.15c33.77,0,61.15,27.38,61.15,61.15 C434.65,105.82,407.27,133.2,373.5,133.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.29,71.77c11.57-9.83,26.19-14.7,41.3-13.79l7.61-0.05c-13.47-13.56-32.64-18.79-50.48-15.14 c-5.14,8.55-8.1,18.56-8.1,29.26c0,3.13,0.26,6.2,0.74,9.19C319.95,77.8,322.94,74.62,326.29,71.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.68,38.74c15.23,1.24,29.27,8.08,39.33,19.54l4.44,4.74c-1.21-19.39-12.49-36.13-28.64-45.04 c-11.72,3.83-21.77,11.37-28.75,21.23C331.51,38.53,336.08,38.36,340.68,38.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.63,104.47c-15.53-0.64-29.89-7.27-40.44-18.66l-4.68-4.78c0.41,19.2,10.76,36.21,26.22,45.83 c13.32-3.69,24.67-12.11,32.14-23.33c-3.52,0.66-7.13,0.99-10.78,0.99C409.27,104.52,408.45,104.51,407.63,104.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.69,70.89c-10.87,10.01-24.82,15.44-39.51,15.44c-0.76,0-1.52-0.01-2.29-0.04l-7.06-0.12 c13.96,13.32,33.45,17.99,51.27,13.69c4.62-8.22,7.26-17.71,7.26-27.82c0-3.78-0.37-7.48-1.08-11.05 C426.84,64.56,423.96,67.88,420.69,70.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.09,106.6c0.58-15.42,7.07-29.72,18.29-40.3l5.26-5.37c-19.05-0.19-36.29,9.47-46.43,24.48 c3.4,14.11,12.06,26.17,23.79,33.99C341.23,115.23,340.92,110.94,341.09,106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.98,23.4c1.01,4.3,1.53,8.75,1.54,13.27c0.04,15.54-5.96,30.18-16.88,41.22l-0.02-0.02v0.02l-5.37,5.37 c19.32-0.39,36.44-10.83,46.05-26.45C424.4,42.72,415.2,30.82,402.98,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.02,119.54c-10.53-11.35-16.14-26.1-15.65-41.56l0-7.37c-13.26,13.91-17.92,33.28-13.73,51.02 c8.23,4.63,17.73,7.28,27.85,7.28c3.79,0,7.49-0.37,11.07-1.08C381.13,125.45,377.93,122.68,375.02,119.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.61,66.17l-0.01,0l0.02,0.02v7.24c12.87-14.57,16.73-34.4,11.6-52.12c-7.72-3.92-16.46-6.14-25.72-6.14 c-4.67,0-9.21,0.57-13.55,1.63c3.75,2.33,7.26,5.1,10.46,8.28C381.42,36.05,387.53,50.64,387.61,66.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.42,98.91h34.4c-0.1-0.23-0.21-0.45-0.3-0.67c-1.59-3.77-2.81-7.65-3.69-11.61h-30.41V68.49h28.9 c0.22-4.31,0.86-8.55,1.89-12.7h-49.63v76.08h61.31v-12.59h-42.46V98.91z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.646d662f639d2b2d28dbec4e0e471aa5.svg";
export { ForwardRef as ReactComponent };